<template>
  <div class="module-container documents-container">
    <div
      class="d-flex flex-row justify-content-between align-items-center mb-3"
    >
      <div class="d-flex flex-row justify-content-start align-items-center">
        <div
          class="main-image-container bg-purple rounded d-flex justify-content-center align-items-center"
        >
          <img
            height="25"
            width="25"
            :src="require('../../assets/icons/documents.svg')"
          />
        </div>
        <h3 class="mb-0 ml-3">Document Archive</h3>
      </div>
      <div class="d-flex">
        <div class="gap-massdocument">
          <b-button
            variant="primary"
            @click="addMassDocument"
            class="smaller-button button-primary-shadow"
            ><i class="fa fa-paper-plane mr-2" aria-hidden="true"></i> Request
            documents</b-button
          >
        </div>
        <b-button
          variant="primary"
          @click="addExpressDocument"
          class="smaller-button button-primary-shadow"
          ><i class="fa fa-shipping-fast mr-2" aria-hidden="true"></i> Express
          Document</b-button
        >
      </div>
    </div>
    <div class="filters-container" ref="filtersContainer">
      <div
        class="d-flex flex-row justify-content-between align-items-center bg-light-gray min-width-fit-content"
      >
        <div class="d-flex flex-wrap align-items-center">
          <b-form-input
            class="auth-input search-input border-color-light-gray"
            v-model="filter.searchPhrase"
            placeholder="Search documents by ref#..."
            :readonly="searchingClients"
          />
          <span class="ml-4 mr-3" style="font-size: 14px;"
            >Active filters:</span
          >
          <div
            class="filter-value bg-white border pr-2 pt-1 pb-1 m-1"
            v-for="(f, fIndex) in filter.formId"
            :key="f.value"
          >
            <div class="d-flex justify-content-between align-items-center">
              <span class="mr-3"
                >Document Type:
                <span class="color-filter">{{ f.label }}</span></span
              >
              <i
                class="fa fa-times text-danger hover-pointer hover-text-almost-black"
                @click="removeFormFilter(fIndex)"
              ></i>
            </div>
          </div>
          <div
            class="filter-value bg-white border pr-2 pt-1 pb-1 m-1"
            v-for="(eoc, eocIndex) in filter.eoc"
            :key="eoc.value"
          >
            <div class="d-flex justify-content-between align-items-center">
              <span class="mr-3"
                >Patient:
                <span class="color-filter">{{ eoc.label }}</span></span
              >
              <i
                class="fa fa-times text-danger hover-pointer hover-text-almost-black"
                @click="removeEocFilter(eocIndex)"
              ></i>
            </div>
          </div>
          <div
            v-if="filter.patientStartDateFrom || filter.patientStartDateTo"
            class="filter-value bg-white border pr-2 pt-1 pb-1 m-1"
          >
            <div class="d-flex justify-content-between align-items-center">
              <span class="mr-3"
                >Patient start/admission date:
                <span class="color-filter"
                  >{{
                    filter.patientStartDateFrom || filter.patientStartDateTo
                      ? `(${
                          filter.patientStartDateFrom
                            ? "From: " +
                              formatDateOnly(filter.patientStartDateFrom)
                            : ""
                        }${
                          filter.patientStartDateFrom &&
                          filter.patientStartDateTo
                            ? " - "
                            : ""
                        }${
                          filter.patientStartDateTo
                            ? "To: " + formatDateOnly(filter.patientStartDateTo)
                            : ""
                        })`
                      : ""
                  }}
                </span></span
              >
              <i
                class="fa fa-times text-danger hover-pointer hover-text-almost-black"
                @click="removePatientStartDateFilter()"
              ></i>
            </div>
          </div>
          <div
            class="filter-value bg-white border pr-2 pt-1 pb-1 m-1"
            v-for="(s, sIndex) in filter.location"
            :key="s.value"
          >
            <div class="d-flex justify-content-between align-items-center">
              <span class="mr-3"
                >Location: <span class="color-filter">{{ s.label }}</span></span
              >
              <i
                class="fa fa-times text-danger hover-pointer hover-text-almost-black"
                @click="removeLocationFilter(sIndex)"
              ></i>
            </div>
          </div>
          <div
            class="filter-value bg-white border pr-2 pt-1 pb-1 m-1"
            v-for="(s, sIndex) in filter.status"
            :key="s.value"
          >
            <div class="d-flex justify-content-between align-items-center">
              <span class="mr-3"
                >Status: <span class="color-filter">{{ s.label }}</span></span
              >
              <i
                class="fa fa-times text-danger hover-pointer hover-text-almost-black"
                @click="removeStatusFilter(sIndex)"
              ></i>
            </div>
          </div>
          <div
            v-if="filter.effectiveDateFrom || filter.effectiveDateTo"
            class="filter-value bg-white border pr-2 pt-1 pb-1 m-1"
          >
            <div class="d-flex justify-content-between align-items-center">
              <span class="mr-3"
                >Effective date:
                <span class="color-filter"
                  >{{
                    filter.effectiveDateFrom || filter.effectiveDateTo
                      ? `(${
                          filter.effectiveDateFrom
                            ? "From: " +
                              formatDateOnly(filter.effectiveDateFrom)
                            : ""
                        }${
                          filter.effectiveDateFrom && filter.effectiveDateTo
                            ? " - "
                            : ""
                        }${
                          filter.effectiveDateTo
                            ? "To: " + formatDateOnly(filter.effectiveDateTo)
                            : ""
                        })`
                      : ""
                  }}
                </span></span
              >
              <i
                class="fa fa-times text-danger hover-pointer hover-text-almost-black"
                @click="removeEffectiveDateFilter()"
              ></i>
            </div>
          </div>
          <div
            class="filter-value bg-white border pr-2 pt-1 pb-1 m-1"
            v-for="(u, uIndex) in filter.completedBy"
            :key="u.value"
          >
            <div class="d-flex justify-content-between align-items-center">
              <span class="mr-3"
                >Completed by:
                <span class="color-filter">{{ u.label }}</span></span
              >
              <i
                class="fa fa-times text-danger hover-pointer hover-text-almost-black"
                @click="removeCompletedByFilter(uIndex)"
              ></i>
            </div>
          </div>
          <div
            v-if="filter.creationDateFrom || filter.creationDateTo"
            class="filter-value bg-white border pr-2 pt-1 pb-1 m-1"
          >
            <div class="d-flex justify-content-between align-items-center">
              <span class="mr-3"
                >Creation date:
                <span class="color-filter"
                  >{{
                    filter.creationDateFrom || filter.creationDateTo
                      ? `(${
                          filter.creationDateFrom
                            ? "From: " + formatDateOnly(filter.creationDateFrom)
                            : ""
                        }${
                          filter.creationDateFrom && filter.creationDateTo
                            ? " - "
                            : ""
                        }${
                          filter.creationDateTo
                            ? "To: " + formatDateOnly(filter.creationDateTo)
                            : ""
                        })`
                      : ""
                  }}
                </span></span
              >
              <i
                class="fa fa-times text-danger hover-pointer hover-text-almost-black"
                @click="removeCreationDateFilter()"
              ></i>
            </div>
          </div>
          <div
            class="filter-value bg-white border pr-2 pt-1 pb-1 m-1"
            v-for="(u, uIndex) in filter.user"
            :key="u.value"
          >
            <div class="d-flex justify-content-between align-items-center">
              <span class="mr-3"
                >Created by:
                <span class="color-filter">{{ u.label }}</span></span
              >
              <i
                class="fa fa-times text-danger hover-pointer hover-text-almost-black"
                @click="removeUserFilter(uIndex)"
              ></i>
            </div>
          </div>
          <span
            v-if="hasFilters"
            class="clear-all-filters text-danger ml-2"
            style="font-size: 14px;"
            @click="clearAllFilters"
            >Clear all filters</span
          >
        </div>
        <div class="d-flex align-self-stretch align-items-center">
          <div class="align-self-stretch" style="padding: 9px 0px;">
            <div class="vertical-separator border-med-light-gray"></div>
          </div>
          <b-dropdown
            id="dropdown-form"
            text="Filters"
            ref="filterDropdown"
            class="container-main bg-light-gray"
            toggle-class="d-flex flex-row justify-content-between align-items-lg-center bg-transparent border-0 color-custom-dark-grey dropdown-menu-label"
            menu-class="container-filter-main-menu"
            toggle-tag="div"
            boundary="window"
            right
            @hide="onFilterHide"
          >
            <template #button-content>
              <div class="d-flex align-items-center mr-2">
                <i
                  class="fas fa-filter mr-2"
                  style="font-size: 15px;"
                  aria-hidden="true"
                ></i>
                <span style="font-size: 14px;">Filters</span>
              </div>
            </template>
            <b-dropdown-form class="px-2">
              <b-form-group label="Filter by:">
                <b-form-select
                  v-model="selectedFilter"
                  :options="
                    filterOptions.filter(
                      f => !this.selectedLocation || f.value != 'location'
                    )
                  "
                />
              </b-form-group>

              <multiple-select-filter
                v-if="selectedFilter == 'documentType'"
                v-model="filter.formId"
                :label="'Document Types'"
                :options="documentTypes"
                :width="filterWidth"
                :showSearch="true"
                :key="'documentType'"
                @on-search="updatePopper"
                @on-text-selection="updateTextSelection"
                ref="documentTypeFilter"
              />
              <multiple-select-filter
                v-if="selectedFilter == 'patient'"
                :label="'Patients'"
                :options="clientOptions"
                v-model="filter.eoc"
                :width="filterPatientWidth"
                :showSearch="true"
                :async="true"
                :searching="searchingClients"
                @on-search="fetchClientOptions"
                @on-text-selection="updateTextSelection"
                :key="'patient'"
                ref="patientFilter"
              >
                <template v-slot:item-option="{ itemOption, selected }">
                  <eoc-filter-option-template
                    :eoc="itemOption.data"
                    :selected="selected"
                  />
                </template>
              </multiple-select-filter>
              <multiple-select-filter
                v-if="selectedFilter == 'completedBy'"
                :label="'Completed By'"
                :options="completedByArray"
                v-model="filter.completedBy"
                :width="filterWidth"
                :showSearch="true"
                @on-search="updatePopper"
                @on-text-selection="updateTextSelection"
                :key="'completedBy'"
                ref="completedByFilter"
              />
              <multiple-select-filter
                v-if="selectedFilter == 'location' && !selectedLocation"
                :label="'Location'"
                :options="locationOptions"
                v-model="filter.location"
                :width="filterWidth"
                :showSearch="false"
                :key="'status'"
              />
              <multiple-select-filter
                v-if="selectedFilter == 'status'"
                :label="'Status'"
                :options="documentStatuses"
                v-model="filter.status"
                :width="filterWidth"
                :showSearch="false"
                :key="'status'"
              />
              <date-range-filter
                v-if="selectedFilter == 'effectiveDate'"
                v-model="filterEffectiveDateRange"
                :filterWidth="filterWidth"
                label="Effective Date"
                :key="'effectiveDate'"
              />
              <date-range-filter
                v-if="selectedFilter == 'creationDate'"
                v-model="filterCreationDateRange"
                :filterWidth="filterWidth"
                label="Creation Date"
                :key="'creationDate'"
              />
              <multiple-select-filter
                v-if="selectedFilter == 'createdBy'"
                :label="'Created By'"
                :options="users"
                v-model="filter.user"
                :width="filterWidth"
                :showSearch="true"
                @on-search="updatePopper"
                @on-text-selection="updateTextSelection"
                :key="'createdBy'"
                ref="createdByFilter"
              />
            </b-dropdown-form>
          </b-dropdown>
        </div>
      </div>
    </div>

    <div class="mt-3 mb-0 w-100 d-flex flex-row justify-content-between">
      <div class="d-flex align-items-center" style="font-size: 19px;">
        <div
          :class="
            documentsSelected.length > 0 ? 'hover-pointer hover-secondary' : ''
          "
          class="px-2 py-1"
          @click="viewMultiple"
        >
          <i
            class="fa fa-search-plus"
            :class="
              documentsSelected.length == 0
                ? 'color-custom-dark-grey'
                : 'text-primary'
            "
            style="font-size:15px;"
          ></i>
          <span
            class="ml-2"
            :class="
              documentsSelected.length > 0
                ? 'text-primary'
                : 'color-custom-dark-grey'
            "
            style="font-size: 14px"
            >View</span
          >
        </div>
        <div
          :class="allowEditSelected ? 'hover-pointer hover-secondary' : ''"
          class="px-2 py-1"
          @click="editMultiple"
        >
          <i
            class="fa fa-edit"
            :class="
              !allowEditSelected ? 'color-custom-dark-grey' : 'text-primary'
            "
            style="font-size:15px;"
          ></i>
          <span
            class="ml-2"
            :class="
              allowEditSelected ? 'text-primary' : 'color-custom-dark-grey'
            "
            style="font-size: 14px"
            >Edit</span
          >
        </div>
        <div
          v-if="hasCurrentUserReportPermission('Documents')"
          class="border-left border-med-light-gray pl-1 ml-1"
          style="width: 1px; height: 19px"
        ></div>
        <a
          v-if="hasCurrentUserReportPermission('Documents')"
          class="hover-pointer"
          style="font-size: 14px"
          @click="showReportRequestsModal = true"
        >
          <i class="fa fa-download"></i>
          <span class="ml-2 text-primary" style="font-size: 14px">Export</span>
        </a>
        <div
          v-if="currentUser && !currentUser.onlyAccessAssignedPatients"
          class="border-left border-med-light-gray pl-1 ml-1 mr-1"
          style="width: 1px; height: 19px"
        ></div>
        <vue-toggles
          v-if="currentUser && !currentUser.onlyAccessAssignedPatients"
          @click="changeAssignedToMEToggle()"
          :value="assignedToMe"
          height="20"
          width="30"
          checkedBg="#34C759"
          uncheckedBg="#FF6161"
        />
        <small
          v-if="currentUser && !currentUser.onlyAccessAssignedPatients"
          class="ml-2"
          >Show My Patients only</small
        >
        <div
          v-if="currentUser && currentUser.role.name != 'Tech Staff'"
          class="ml-2 border-left border-med-light-gray pl-1 ml-1 mr-1"
          style="width: 1px; height: 19px"
        ></div>
        <vue-toggles
          v-if="currentUser && currentUser.role.name != 'Tech Staff'"
          @click="changeSeeSuperviseesPendingDocumentsToggle()"
          :value="seeSuperviseesPendingDocuments"
          height="20"
          width="30"
          checkedBg="#34C759"
          uncheckedBg="#FF6161"
        />
        <small
          v-if="currentUser && currentUser.role.name != 'Tech Staff'"
          class="ml-2"
          >Show only my supervisee’s pending documents</small
        >
      </div>
      <div class="d-flex flex-row justify-content-end align-items-center">
        <top-paginator
          :total="listTotal"
          :page="filter.page"
          :perPage="filter.pageSize"
          @change-page="changePage"
        />
      </div>
    </div>
    <div
      :style="
        `--document-list-filters-container-height:calc(${filtersContainerHeight}px);`
      "
    >
      <grid
        ref="grid"
        :columns="columns"
        :data="items"
        :store="gridConfig.store"
        :selectionMode="gridConfig.selectionMode"
        :columnLines="gridConfig.columnLines"
        :groupFeature="false"
        :autoHeight="false"
        :searchFeature="true"
        :stripeFeature="false"
        @storesort="listeners.storeSort"
        @selectionchange="listeners.selectionChange"
        @renderrows="hookDropdownButtons"
        @renderrow="hookDropdownButtons"
      />
    </div>

    <document-file-add-edit-modal
      v-if="showAddFileEditor"
      v-model="showAddFileEditor"
      :formId="editFile.formId"
      :eocId="editFile.eocId"
      @onModify="onModifyAddFile"
      :clientId="editFile.clientId"
      :submitId.sync="editFile.submitId"
    />
    <document-add-edit-modal
      v-if="showAddDocumentEditor"
      v-model="showAddDocumentEditor"
      :formId="editDocument.formId"
      :clientId="editDocument.clientId"
      :eocId="editDocument.eocId"
      :submitId="editDocument.submitId"
      :documentRefNumber="editDocument.documentRefNumber"
      @onModify="onModifyAddDocument"
    />
    <document-group-add-edit-modal
      v-if="showAddDocumentGroupEditor"
      v-model="showAddDocumentGroupEditor"
      :formGroupId="editDocumentGroup.formGroupId"
      :clientId="editDocumentGroup.clientId"
      :eocId="editDocumentGroup.eocId"
      :submitId="editDocumentGroup.submitId"
      @onModify="onModifyAddDocumentGroup"
    />
    <document-group-file-add-edit-modal
      v-if="showAddDocumentGroupFileEditor"
      v-model="showAddDocumentGroupFileEditor"
      :formGroupId="editDocumentGroup.formGroupId"
      :clientId="editDocumentGroup.clientId"
      :eocId="editDocumentGroup.eocId"
      :submitId="editDocumentGroup.submitId"
      @onModify="onModifyAddDocumentGroupFile"
    />
    <document-view-modal
      v-if="documentViewModal.show"
      v-model="documentViewModal.show"
      :documentId="documentViewModal.id"
      @onModify="onModifyAddDocument"
    />
    <document-group-view-modal
      v-if="documentGroupViewModal.show"
      v-model="documentGroupViewModal.show"
      :formGroupId="documentGroupViewModal.formGroupId"
      :documentGroupId="documentGroupViewModal.documentGroupId"
      @onModify="onModifyAddDocumentGroup"
    />
    <document-share-multiple-modal
      v-if="showDocumentShareModal"
      v-model="showDocumentShareModal"
      :patientId="selectedForms[0].patientId"
      :eocId="selectedForms[0].episodeOfCareId"
      :forms="selectedForms"
      @onModify="onShareDocument"
    />
    <documents-mass-edit-modal
      v-if="showMassEditDocumentsEditor"
      v-model="showMassEditDocumentsEditor"
      :documentIds="massEditDocumentIds"
      @onModify="onModifyMassEditDocuments"
    />
    <b-modal
      centered
      ref="form-modal"
      title="New Document"
      header-bg-variant="primary"
      header-text-variant="white"
      @ok="createNewExpressDocument"
      no-close-on-backdrop
      header-class="bg-purple"
    >
      <template v-slot:modal-footer="{ ok, cancel }">
        <b-button variant="secondary" @click="cancel()">
          Cancel
        </b-button>
        <b-button variant="primary" @click="ok()">
          Create
        </b-button>
      </template>
      <b-form-group
        v-if="!selectedLocation"
        label="Location"
        class="w-100 mr-4"
      >
        <template v-slot:label>
          Location
        </template>
        <v-select
          :clearable="false"
          class="w-100"
          v-model="expressDocument.location"
          :options="locationOptions"
          @input="fetchClientOptionsPicker('', () => {})"
        ></v-select>
      </b-form-group>
      <b-form-group label="Patient">
        <eoc-picker
          :eocs="clientOptionsPicker"
          v-model="expressDocument.client"
          :async="true"
          @search="
            ({ search, loading }) => fetchClientOptionsPicker(search, loading)
          "
        />
      </b-form-group>
      <b-form-group label="Document Type"
        ><v-select
          class=""
          :options="documentTypesNewDocument"
          v-model="expressDocument.documentType"
        ></v-select
      ></b-form-group>
    </b-modal>
    <mass-share-documents
      v-if="showMassShareDocuments"
      v-model="showMassShareDocuments"
      @setOpen="
        newValue => {
          showMassShareDocuments = newValue;
        }
      "
      @close="showMassShareDocuments = false"
      :clientOptionsPicker="clientOptionsPicker"
      @search="(search, loading) => fetchClientOptionsPicker(search, loading)"
      :documentTypesExpress="documentTypesExpress"
    />
    <report-request-index
      v-if="showReportRequestsModal"
      v-model="showReportRequestsModal"
      :reportFilters="exportFilter"
      reportName="Documents"
    />
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import Grid from "../../third_party/grid/Grid.vue";
import {
  formatStartDateSql,
  formatEndDateSql,
  formatDate
} from "../../helpers/date";
import documentServer from "../../server/document";
import documentGroupServer from "../../server/documentGroup";
import eocServer from "../../server/eoc";
import formSubmitterServer from "../../server/formSubmitter";
import userServer from "../../server/user";
import formGroupServer from "../../server/formGroup";
import DocumentFileAddEditModal from "../episode_of_care/document/DocumentFileAddEditModal.vue";
import DocumentAddEditModal from "../episode_of_care/document/DocumentAddEditModal.vue";
import DocumentGroupAddEditModal from "../episode_of_care/document_group/DocumentGroupAddEditModal.vue";
import DocumentGroupFileAddEditModal from "../episode_of_care/document_group/DocumentGroupFileAddEditModal.vue";
import EocPicker from "../controls/EocPicker";
import TopPaginator from "../controls/TopPaginator.vue";
import EocFilterOptionTemplate from "../../views/EocFilterOptionTemplate";
import DocumentViewModal from "../episode_of_care/document/DocumentViewModal.vue";
import DocumentGroupViewModal from "../episode_of_care/document_group/DocumentGroupViewModal.vue";
import DocumentShareMultipleModal from "../episode_of_care/document/DocumentShareMultipleModal.vue";
import DocumentsMassEditModal from "./DocumentsMassEditModal";
import ReportRequestIndex from "../report_request/ReportRequestIndex.vue";
import locationServer from "../../server/location";
import MassShareDocuments from "./MassShareDocuments";

export default {
  name: "DocumentArchiveIndex",
  components: {
    Grid,
    TopPaginator,
    DocumentAddEditModal,
    DocumentFileAddEditModal,
    DocumentGroupAddEditModal,
    EocPicker,
    EocFilterOptionTemplate,
    ReportRequestIndex,
    DocumentViewModal,
    DocumentGroupViewModal,
    DocumentShareMultipleModal,
    DocumentsMassEditModal,
    DocumentGroupFileAddEditModal,
    MassShareDocuments
  },
  props: ["category", "showing"],
  data() {
    const self = this;
    return {
      list: [],
      listTotal: 0,
      documentStatuses: [
        {
          value: "Draft",
          label: "Draft"
        },
        {
          value: "Pending",
          label: "Pending"
        },
        {
          value: "Completed",
          label: "Completed"
        }
      ],
      locationOptions: [],
      clientOptions: [],
      filterWidth: "250px",
      filterPatientWidth: "350px",
      selectedFilter: "documentType",
      filterOptions: [
        {
          value: "documentType",
          text: "Document Type"
        },
        {
          value: "patient",
          text: "Patient"
        },
        {
          value: "completedBy",
          text: "Completed by"
        },
        {
          value: "location",
          text: "Location"
        },
        {
          value: "status",
          text: "Status"
        },
        {
          value: "effectiveDate",
          text: "Effective date"
        },
        {
          value: "creationDate",
          text: "Creation date"
        },
        {
          value: "createdBy",
          text: "Created by"
        }
      ],
      filter: {
        searchPhrase: "",
        formId: [],
        status: [],
        eoc: [],
        location: [],
        user: [],
        completedBy: [],
        creationDateFrom: null,
        creationDateTo: null,
        effectiveDateFrom: null,
        effectiveDateTo: null,
        patientStartDateFrom: null,
        patientStartDateTo: null,
        page: 0,
        pageSize: 50,
        orderBy: "creationDate",
        orderByDescending: true
      },
      gridConfig: {
        minHeight: "20em",
        selectionMode: {
          row: true,
          checkbox: true,
          rowCheckboxSelection: true,
          showCheckAll: true
        },
        columnLines: false,
        store: {
          // Default sorters
          sorters: [{ field: "creationDate", ascending: false }]
        }
      },
      showResults: false,
      showAddFileEditor: false,
      editFile: {
        submitId: null,
        formId: null,
        clientId: null,
        eocId: null
      },
      showAddDocumentEditor: false,
      editDocument: {
        submitId: null,
        formId: null,
        clientId: null,
        eocId: null,
        documentRefNumber: null
      },
      showAddDocumentGroupEditor: false,
      editDocumentGroup: {
        submitId: null,
        formGroupId: null,
        clientId: null,
        eocId: null
      },
      documentViewModal: {
        show: false,
        id: null
      },
      documentGroupViewModal: {
        show: false,
        formGroupId: null,
        documentGroupId: null
      },
      showDocumentShareModal: false,
      massEditDocumentIds: [],
      showMassEditDocumentsEditor: false,
      selectedForms: [],
      lastTimeout: null,
      lastTimeoutClientOptionsPicker: null,
      users: [],
      completedByArray: [],
      expressDocument: {
        client: null,
        documentType: null,
        location: null
      },
      showMassShareDocuments: false,
      clientOptionsPicker: [],
      documentsSelected: [],
      listeners: {
        selectionChange: selectionEvent => {
          self.documentsSelected = selectionEvent.selection
            .filter(s => s.data.mode != "File")
            .map(s => ({
              submitId: s.data.documentId,
              formId: s.data.form.id,
              versionId: null,
              eocId: s.data.episodeOfCare.id,
              clientId: s.data.patient.id,
              mode: s.data.mode,
              status: s.status
            }));
        },
        storeSort: sortData => {
          if (sortData.sorters.length == 1) {
            const sorter = sortData.sorters[0];
            const ascending = sorter.ascending;
            const field = sorter.field;
            self.filter.orderBy = field;
            self.filter.orderByDescending = !ascending;
            self.changePage(0);
          }
        }
      },
      multipleForms: [],
      searchingClients: false,
      filtersContainerHeight: 0,
      filterTextSelection: null,
      showAddDocumentGroupFileEditor: false,
      showReportRequestsModal: false,
      documentTypesNewDocument: []
    };
  },

  methods: {
    ...mapActions("layout", [
      "showAlertSuccess",
      "toggleAssignToMeDocArchiveIndex",
      "toggleSeeSuperviseesPendingDocuments"
    ]),
    ...mapActions("formBuilder", ["fetchFormBuilderForms"]),
    ...mapActions("formGroup", ["fetchFormGroups"]),
    ...mapActions("client", [
      "fetchAllergyTypes",
      "fetchAllergens",
      "fetchReactions",
      "fetchAllergySeverities"
    ]),
    async fetchInitialData() {
      this.fetchFormBuilderForms({ category: "main" });
      this.fetchFormBuilderForms({ category: "groupSession" });
      this.fetchFormBuilderForms({ category: "eocAdditionalInfo" });
      this.fetchFormBuilderForms({ category: "masterTreatmentPlan" });
      this.fetchFormBuilderForms({ category: "doctorOrder" });
      this.fetchFormBuilderForms({ category: "releaseOfInformation" });
      this.fetchFormGroups();
      this.getUsers();
      this.calculateFilterWidth();
      this.searchDocuments(false);
      this.fetchClientOptions("");
      this.fetchAllergyTypes();
      this.fetchAllergens();
      this.fetchReactions();
      this.fetchAllergySeverities();
    },
    searchDocuments(delayed = true) {
      if (delayed) {
        if (this.lastTimeout) {
          clearTimeout(this.lastTimeout);
          this.lastTimeout = null;
        }
        this.lastTimeout = setTimeout(async () => {
          this.fetchDocuments();
        }, 1000);
      } else this.fetchDocuments();

      this.showResults = true;
    },
    async getUsers() {
      const users = await userServer.getMinimalUsers();
      this.users = users.map(user => ({
        value: user.id,
        label: this.formatUser(user)
      }));
      this.completedByArray = users.map(user => ({
        value: user.id,
        label: this.formatUser(user)
      }));
    },
    changePage(page) {
      this.filter.page = page;
      this.fetchDocuments();
      this.scrollGridToTop();
    },
    scrollGridToTop() {
      const grid = document.querySelector(".documents-container .b-grid");
      grid.scrollTop = 0;
    },
    changeAssignedToMEToggle() {
      this.toggleAssignToMeDocArchiveIndex();
      this.fetchDocuments();
    },
    changeSeeSuperviseesPendingDocumentsToggle() {
      this.toggleSeeSuperviseesPendingDocuments();
      this.fetchDocuments();
    },
    async fetchDocuments() {
      const result = await documentServer.queryImproved({
        searchPhrase:
          this.filter.searchPhrase.length >= 3 ? this.filter.searchPhrase : "",
        episodeOfCareId: this.filter.eoc.map(eoc => eoc.value),
        locationId: this.filter.location.map(eoc => eoc.value),
        formId: this.filter.formId.map(f => f.value),
        status: this.filter.status.map(s => s.value),
        fromDate: formatStartDateSql(this.filter.creationDateFrom),
        toDate: formatEndDateSql(this.filter.creationDateTo),
        effectiveFromDate: formatStartDateSql(this.filter.effectiveDateFrom),
        effectiveToDate: formatEndDateSql(this.filter.effectiveDateTo),
        patientStartFromDate: formatStartDateSql(
          this.filter.patientStartDateFrom
        ),
        patientStartToDate: formatEndDateSql(this.filter.patientStartDateTo),
        createdBy: this.filter.user.map(u => u.value),
        completedBy: this.filter.completedBy.map(u => u.value),
        page: this.filter.page,
        pageSize: this.filter.pageSize,
        orderBy: this.filter.orderBy,
        orderByDescending: this.filter.orderByDescending,
        category: [
          "main",
          "groupSession",
          "masterTreatmentPlan",
          "masterTreatmentPlanReview",
          "doctorOrder",
          "releaseOfInformation"
        ],
        assignedToMe: this.assignedToMe,
        seeSuperviseesPendingDocuments: this.seeSuperviseesPendingDocuments
      });
      this.list = result.documents;
      this.listTotal = result.count;
    },
    async fetchLocationOptions() {
      const locations = await locationServer.query({});
      this.locationOptions = locations.map(location => ({
        value: location.id,
        label: location.name
      }));
      this.initExpressDocumentLocation();
    },
    async fetchClientOptions(search) {
      if (this.lastTimeoutClientOptions) {
        clearTimeout(this.lastTimeoutClientOptions);
        this.lastTimeoutClientOptions = null;
      }
      this.lastTimeoutClientOptions = setTimeout(async () => {
        if (!search || search.length == 0 || search.length >= 3) {
          this.searchingClients = true;
          const optionsResult = await eocServer.queryList(
            {
              searchPhrase: search,
              eocStatus:
                !search || search.length == 0 ? ["Active", "Pending"] : [],
              page: 1,
              pageSize: 50
            },
            {
              "Hide-Loading": true
            }
          );
          this.clientOptions = optionsResult.episodesOfCare.map(eoc => ({
            value: eoc.id,
            label: this.formatEocObj(eoc),
            data: eoc
          }));
          this.searchingClients = false;
        }
      }, 1000);
    },
    async fetchClientOptionsPicker(search, loading) {
      if (this.lastTimeoutClientOptionsPicker) {
        clearTimeout(this.lastTimeoutClientOptionsPicker);
        this.lastTimeoutClientOptionsPicker = null;
      }
      if (search && search.trim().length >= 3) {
        this.clientOptionsPicker = [];
      }
      this.lastTimeoutClientOptionsPicker = setTimeout(async () => {
        loading(true);
        if (!search || search.length == 0 || search.length >= 3) {
          this.searchingClients = true;
          const optionsResult = (
            await eocServer.queryList(
              {
                searchPhrase: search,
                eocStatus:
                  !search || search.length == 0 ? ["Active", "Pending"] : [],
                orderBy: "status",
                page: 1,
                pageSize: 50
              },
              {
                "Hide-Loading": true
              }
            )
          ).episodesOfCare.filter(
            eoc =>
              !this.expressDocument.location ||
              eoc.locationId == this.expressDocument.location.value
          );
          this.clientOptionsPicker = optionsResult.map(eoc => ({
            value: eoc.id,
            label: this.formatEocObj(eoc),
            data: eoc
          }));
          if (this.expressDocument.location) {
            const location = await this.getLocation(
              this.expressDocument.location.value
            );
            this.documentTypesNewDocument = this.documentTypesExpress.filter(
              d => location?.formIds?.includes(d.value)
            );
          } else {
            this.documentTypesNewDocument = this.documentTypesExpress;
          }
          this.searchingClients = false;
        }
        loading(false);
      }, 1000);
    },
    onModifyAddFile(eventData) {
      this.showAddFileEditor = false;
      if (eventData.refetchDocuments) this.fetchDocuments();
    },
    onModifyAddDocument(eventData) {
      this.showAddDocumentEditor = false;
      if (eventData.refetchDocuments) this.fetchDocuments();
    },
    onModifyAddDocumentGroup(eventData) {
      this.showAddDocumentGroupEditor = false;
      if (eventData.refetchDocuments) this.fetchDocuments();
    },
    onModifyAddDocumentGroupFile(eventData) {
      this.showAddDocumentGroupFileEditor = false;
      if (eventData.refetchDocuments) this.fetchDocuments();
    },
    onModifyMassEditDocuments(eventData) {
      eventData.noCloseEditDocumentEditor
        ? null
        : (this.showMassEditDocumentsEditor = false);
      if (eventData.refetchDocuments) this.fetchDocuments();
    },
    removeFormFilter(index) {
      const newValue = [...this.filter.formId];
      newValue.splice(index, 1);
      this.filter.formId = newValue;
    },
    removeEocFilter(index) {
      const newValue = [...this.filter.eoc];
      newValue.splice(index, 1);
      this.filter.eoc = newValue;
    },
    removePatientStartDateFilter() {
      this.filter.patientStartDateFrom = null;
      this.filter.patientStartDateTo = null;
    },
    removeLocationFilter(index) {
      const newValue = [...this.filter.location];
      newValue.splice(index, 1);
      this.filter.location = newValue;
    },
    removeStatusFilter(index) {
      const newValue = [...this.filter.status];
      newValue.splice(index, 1);
      this.filter.status = newValue;
    },
    removeCreationDateFilter() {
      this.filter.creationDateFrom = null;
      this.filter.creationDateTo = null;
    },
    removeEffectiveDateFilter() {
      this.filter.effectiveDateFrom = null;
      this.filter.effectiveDateTo = null;
    },
    removeUserFilter(index) {
      const newValue = [...this.filter.user];
      newValue.splice(index, 1);
      this.filter.user = newValue;
    },
    removeCompletedByFilter(index) {
      const newValue = [...this.filter.completedBy];
      newValue.splice(index, 1);
      this.filter.completedBy = newValue;
    },
    calculateFilterWidth() {
      this.filterWidth = "250px";
    },
    clearAllFilters() {
      this.filter.formId = [];
      this.filter.status = [];
      this.filter.client = [];
      this.filter.location = [];
      this.filter.eoc = [];
      this.filter.user = [];
      this.filter.completedBy = [];
      this.filter.creationDateFrom = null;
      this.filter.creationDateTo = null;
      this.filter.effectiveDateFrom = null;
      this.filter.effectiveDateTo = null;
      this.filter.patientStartDateFrom = null;
      this.filter.patientStartDateTo = null;
    },
    addExpressDocument() {
      this.expressDocument = {
        client: null,
        documentType: null,
        location: null
      };
      this.initExpressDocumentLocation();
      this.fetchClientOptionsPicker("", () => {});
      this.$refs["form-modal"].show();
    },
    initExpressDocumentLocation() {
      this.expressDocument.location = this.selectedLocation
        ? null
        : this.locationOptions.length > 0
        ? this.locationOptions[0]
        : null;
    },
    createNewExpressDocument() {
      this.$refs["form-modal"].hide();
      if (this.expressDocument.documentType.type == "form") {
        this.editDocument.submitId = null;
        this.editDocument.clientId = this.expressDocument.client.data.patient.id;
        this.editDocument.eocId = this.expressDocument.client.value;
        this.editDocument.formId = this.expressDocument.documentType.value;
        this.showAddDocumentEditor = true;
      } else {
        this.editDocumentGroup.submitId = null;
        this.editDocumentGroup.clientId = this.expressDocument.client.data.patient.id;
        this.editDocumentGroup.eocId = this.expressDocument.client.value;
        this.editDocumentGroup.formGroupId = this.expressDocument.documentType.value;
        this.showAddDocumentGroupEditor = true;
      }
    },
    addMassDocument() {
      this.fetchClientOptionsPicker("", () => {});
      this.showMassShareDocuments = true;
    },
    async getFormsEditViewMultipleData() {
      const formsData = [];
      for (let index = 0; index < this.documentsSelected.length; index++) {
        const documentSelected = this.documentsSelected[index];
        if (documentSelected.mode == "Group") {
          const formGroup = await formGroupServer.get(documentSelected.formId);
          const formGroupSubmit = await documentGroupServer.get(
            documentSelected.submitId
          );
          for (let index2 = 0; index2 < formGroup.formIds.length; index2++) {
            const formId = formGroup.formIds[index2];
            let submitId = null;

            for (
              let index3 = 0;
              index3 < formGroupSubmit.results.length;
              index3++
            ) {
              const result = formGroupSubmit.results[index3];
              if (result.formId == formId) submitId = result.documentId;
            }
            if (
              submitId &&
              !formsData.map(fD => fD.submitId).includes(submitId)
            ) {
              formsData.push({
                ...documentSelected,
                formId,
                submitId
              });
            }
          }
        } else if (
          !formsData.map(fD => fD.submitId).includes(documentSelected.submitId)
        ) {
          formsData.push(documentSelected);
        }
      }
      return formsData;
    },
    async viewMultiple() {
      if (this.documentsSelected.length == 0) {
        return;
      }

      let documentIds = this.documentsSelected
        .filter(u => u.mode != "Group" && u.mode != "File")
        .map(u => u.submitId);

      const documentGroupsIds = this.documentsSelected
        .filter(u => u.mode == "Group")
        .map(u => u.submitId);

      if (documentGroupsIds.length) {
        const resultsIds = await documentGroupServer.documentGroupsResultsIds(
          documentGroupsIds
        );

        documentIds = [...documentIds, ...resultsIds];
      }

      documentIds = documentIds.filter((value, index, self) => {
        return self.indexOf(value) === index;
      });

      this.documentViewModal = {
        show: true,
        id: documentIds.length == 1 ? documentIds[0] : documentIds
      };
    },
    async editMultiple() {
      if (!this.allowEditSelected) {
        return;
      }

      let documentIds = this.documentsSelected
        .filter(
          u =>
            u.mode != "Group" &&
            u.mode != "File" &&
            this.hasCurrentUserDocumentPermission(u.formId, "hasEntryAccess")
        )
        .map(u => u.submitId);

      const documentGroupsIds = this.documentsSelected
        .filter(u => u.mode == "Group")
        .map(u => u.submitId);

      if (documentGroupsIds.length) {
        const resultsIds = await documentGroupServer.documentGroupsResultsIds(
          documentGroupsIds
        );

        documentIds = [...documentIds, ...resultsIds];
      }

      documentIds = documentIds.filter((value, index, self) => {
        return self.indexOf(value) === index;
      });

      this.massEditDocumentIds = documentIds;
      this.showMassEditDocumentsEditor = true;
    },
    computeHeights() {
      setTimeout(() => {
        const filtersContainerHeight = this.$refs.filtersContainer.clientHeight;
        this.filtersContainerHeight = filtersContainerHeight;
      }, 0);
    },
    openDocumentEditor(record) {
      if (record.mode == "File") {
        if (record.type == "Group") {
          this.editDocumentGroup.submitId = record.documentId;
          this.editDocumentGroup.clientId = record.patient.id;
          this.editDocumentGroup.eocId = record.episodeOfCare.id;
          this.editDocumentGroup.formGroupId = record.form.id;
          this.showAddDocumentGroupFileEditor = true;
        } else {
          this.editFile.submitId = record.documentId;
          this.editFile.clientId = record.patient.id;
          this.editFile.eocId = record.episodeOfCare.id;
          this.editFile.formId = record.form.id;
          this.showAddFileEditor = true;
        }
      } else if (record.type == "Document") {
        this.editDocument.submitId = record.documentId;
        this.editDocument.clientId = record.patient.id;
        this.editDocument.eocId = record.episodeOfCare.id;
        this.editDocument.formId = record.form.id;
        this.editDocument.documentRefNumber = record.documentRefNumber;
        this.showAddDocumentEditor = true;
      } else {
        this.editDocumentGroup.submitId = record.documentId;
        this.editDocumentGroup.clientId = record.patient.id;
        this.editDocumentGroup.eocId = record.episodeOfCare.id;
        this.editDocumentGroup.formGroupId = record.form.id;
        this.editDocument.documentRefNumber = record.documentRefNumber;
        this.showAddDocumentGroupEditor = true;
      }

      this.showDocumentViewModal = { show: false, id: null };
    },
    onShareDocument() {
      this.showDocumentShareModal = false;
    },
    updatePopper() {
      this.$refs.filterDropdown.updatePopper();
    },
    onFilterHide(event) {
      let ref = null;
      if (this.selectedFilter == "documentType") {
        ref = this.$refs.documentTypeFilter;
      }
      if (this.selectedFilter == "patient") {
        ref = this.$refs.patientFilter;
      }
      if (this.selectedFilter == "createdBy") {
        ref = this.$refs.createdByFilter;
      }
      if (this.selectedFilter == "completedBy") {
        ref = this.$refs.completedByFilter;
      }
      if (this.filterTextSelection) {
        if (this.filterTextSelection) event.preventDefault();
        ref.highlightText();
        this.filterTextSelection = null;
      }
    },
    updateTextSelection(textSelection) {
      this.filterTextSelection = textSelection;
    },
    async getLocation(locationId) {
      return await locationServer.get(locationId);
    }
  },
  computed: {
    ...mapState("formBuilder", {
      allForms: state => state.list
    }),
    ...mapState("client", {
      locations: state => state.locations
    }),
    ...mapState("layout", {
      currentUser: state => state.currentUser
    }),
    ...mapGetters("layout", [
      "hasCurrentUserDocumentPermission",
      "hasCurrentUserReportPermission"
    ]),
    ...mapState("layout", {
      selectedLocation: state => state.selectedLocation,
      assignedToMe: state => state.assignedToMeDocArchiveIndex,
      seeSuperviseesPendingDocuments: state =>
        state.seeSuperviseesPendingDocuments
    }),

    ...mapGetters("client", ["formsCurrentLocation"]),
    forms() {
      return this.formsCurrentLocation
        .filter(form =>
          this.hasCurrentUserDocumentPermission(form.id, "hasEntryAccess")
        )
        .map(form => ({
          value: form.id,
          label: form.name,
          type: "form"
        }));
    },
    ...mapGetters("client", ["formGroupsCurrentLocation"]),
    formGroups() {
      const formGroupsCurrentLocation = [...this.formGroupsCurrentLocation];
      return formGroupsCurrentLocation
        .filter(
          formGroup =>
            this.hasCurrentUserDocumentPermission(
              formGroup.id,
              "hasEntryAccess"
            ) && formGroup.formIds?.length > 0
        )
        .map(form => ({
          value: form.id,
          label: form.name,
          type: "formGroup"
        }));
    },
    groupSessionForms() {
      return this.allForms["groupSession"].map(form => ({
        value: form.id,
        label: form.name,
        type: "form"
      }));
    },
    masterTreatmentPlanForms() {
      return this.allForms["masterTreatmentPlan"].map(form => ({
        value: form.id,
        label: form.name,
        type: "form"
      }));
    },
    masterTreatmentPlanReviewForms() {
      return this.allForms["masterTreatmentPlanReview"].map(form => ({
        value: form.id,
        label: form.name,
        type: "form"
      }));
    },
    doctorOrderForms() {
      return this.allForms["doctorOrder"].map(form => ({
        value: form.id,
        label: form.name,
        type: "form"
      }));
    },
    documentTypes() {
      return [
        ...this.forms,
        ...this.groupSessionForms,
        ...this.masterTreatmentPlanForms,
        ...this.masterTreatmentPlanReviewForms,
        ...this.doctorOrderForms,
        ...this.formGroups
      ].sort((a, b) =>
        a.label.toLowerCase().localeCompare(b.label.toLowerCase())
      );
    },

    documentTypesExpress() {
      return [...this.forms, ...this.formGroups].sort((a, b) =>
        a.label.toLowerCase().localeCompare(b.label.toLowerCase())
      );
    },
    allowEditSelected() {
      let hasEntryAccess = this.documentsSelected.find(d =>
        this.hasCurrentUserDocumentPermission(d.formId, "hasEntryAccess")
      );
      return this.documentsSelected.length && hasEntryAccess;
    },
    filterPatientStartDateRange: {
      get() {
        return {
          dateFrom: this.filter.patientStartDateFrom,
          dateTo: this.filter.patientStartDateTo
        };
      },
      set(newValue) {
        this.filter.patientStartDateFrom = newValue.dateFrom;
        this.filter.patientStartDateTo = newValue.dateTo;
      }
    },
    filterEffectiveDateRange: {
      get() {
        return {
          dateFrom: this.filter.effectiveDateFrom,
          dateTo: this.filter.effectiveDateTo
        };
      },
      set(newValue) {
        this.filter.effectiveDateFrom = newValue.dateFrom;
        this.filter.effectiveDateTo = newValue.dateTo;
      }
    },
    filterCreationDateRange: {
      get() {
        return {
          dateFrom: this.filter.creationDateFrom,
          dateTo: this.filter.creationDateTo
        };
      },
      set(newValue) {
        this.filter.creationDateFrom = newValue.dateFrom;
        this.filter.creationDateTo = newValue.dateTo;
      }
    },
    items() {
      return this.list.map(item => ({
        ...item,
        cls: item.mode == "File" ? "file-result-row" : ""
      }));
    },
    columns() {
      const self = this;
      return [
        {
          text: "Ref#",
          field: "documentRefNumber",
          width: 60,
          editor: false
        },
        {
          text: "Document Type",
          field: "documentType",
          type: "template",
          flex: 1,
          editor: false,
          template: ({ record }) => {
            let formName = record.data.form ? record.data.form.name : "";
            if (record.data.form.category == "masterTreatmentPlan")
              formName = "Treatment Plan";
            if (
              record.data.form.category == "masterTreatmentPlan" &&
              record.data.document?.parentDocumentId
            )
              formName = "Treatment Plan Review";
            return (
              formName +
              (record.data.type == "Document" && record.data.mode == "File"
                ? "<i class='fa fa-file-upload text-info ml-2'></i>"
                : "") +
              (record.data.document?.fileName
                ? ` (${record.data.document.fileName})`
                : "")
            );
          },
          sortable() {
            return self.filter.orderByDescending ? -1 : 1;
          }
        },
        {
          text: "Patient Name",
          field: "patientName",
          type: "template",
          flex: 1,
          editor: false,
          template: data =>
            data.record.data.patient
              ? this.formatEoc(
                  data.record.data.patient.firstName,
                  data.record.data.patient.middleName,
                  data.record.data.patient.preferredName,
                  data.record.data.patient.lastName,
                  data.record.data.patient.mrn,
                  data.record.data.episodeOfCare.eocn
                )
              : "",
          sortable() {
            return self.filter.orderByDescending ? -1 : 1;
          }
        },
        {
          text: "Location",
          field: "location",
          type: "template",
          flex: 1,
          editor: false,
          template: data =>
            data.record.data.episodeOfCare.location
              ? data.record.data.episodeOfCare.location.name
              : "",
          sortable() {
            return self.filter.orderByDescending ? -1 : 1;
          }
        },
        {
          text: "Status",
          field: "status",
          type: "template",
          width: 120,
          editor: false,
          template: data => {
            const status = data.record.data.status;
            let className = "warning";
            if (status == "Completed") {
              className = "success";
            }
            if (status == "Draft") {
              className = "danger";
            }
            return `<span class="badge-v2 py-2 badge-${className} badge-fixed-size">${status}</span>`;
          },
          sortable() {
            return self.filter.orderByDescending ? -1 : 1;
          }
        },
        {
          text: "Effective date",
          field: "effectiveDate",
          type: "template",
          width: 160,
          editor: false,
          template: data =>
            data.record.data.effectiveDate
              ? formatDate(data.record.data.effectiveDate)
              : "",
          sortable() {
            return self.filter.orderByDescending ? -1 : 1;
          }
        },
        {
          text: "Creation date",
          field: "creationDate",
          type: "template",
          width: 160,
          editor: false,
          template: data => formatDate(data.record.data.createdAt),
          sortable() {
            return self.filter.orderByDescending ? -1 : 1;
          }
        },
        {
          text: "Created by",
          field: "createdBy",
          type: "template",
          flex: 1,
          editor: false,
          template: data =>
            data.record.data.createdBy
              ? this.formatUser(data.record.data.createdBy)
              : "",
          sortable() {
            return self.filter.orderByDescending ? -1 : 1;
          }
        },
        {
          text: "Completed By",
          field: "completedBy",
          type: "template",
          flex: 1,
          editor: false,
          template: data =>
            data.record.data.completedBy
              ? this.formatUser(data.record.data.completedBy)
              : "",
          sortable() {
            return self.filter.orderByDescending ? -1 : 1;
          }
        },
        {
          text: "Score",
          field: "scoreAndNotes",
          type: "template",
          flex: 1,
          template: ({ record }) => {
            return record.data.score && !isNaN(record.data.score)
              ? record.data.score
              : "";
          },
          sortable() {
            return self.filter.orderByDescending ? -1 : 1;
          }
        },
        {
          text: "",
          type: "action",
          align: "right",
          cellCls: "pointer-cell",
          width: 80,
          actions: [
            {
              renderer: () =>
                `<i class="fa fa-search-plus color-custom-dark-grey hover-text-primary b-action-item  grid-action-icon"></i>`,
              onClick: ({ record }) => {
                if (record.data.mode == "File") {
                  let url = "";
                  if (record.data.type == "Group") {
                    url = documentGroupServer.viewUrl(record.data.documentId);
                  } else {
                    url = formSubmitterServer.viewUrl(record.data.documentId);
                  }
                  window.open(url, "_blank");
                } else if (record.data.type == "Group") {
                  this.documentGroupViewModal = {
                    show: true,
                    formGroupId: record.data.form.id,
                    documentGroupId: record.data.documentId
                  };
                } else {
                  this.documentViewModal = {
                    show: true,
                    id: record.data.documentId
                  };
                }
              }
            },
            {
              renderer: ({ record }) => {
                if (
                  !this.hasCurrentUserDocumentPermission(
                    record.form.id,
                    "isReadOnly"
                  )
                )
                  return "";
                const actions = [];

                if (
                  (record.status == "Draft" ||
                    this.hasCurrentUserDocumentPermission(
                      record.form.id,
                      "hasEntryAccess"
                    )) &&
                  record.category != "doctorOrder"
                ) {
                  actions.push({
                    content: "Share Document",
                    callback: () => {
                      this.selectedForms = [
                        {
                          formVersionId: record.versionId,
                          formId:
                            record.mode == "Group" ? null : record.form.id,
                          formGroupId:
                            record.mode == "Group" ? record.form.id : null,
                          documentId:
                            record.mode == "Group" ? null : record.documentId,
                          documentGroupId:
                            record.mode == "Group" ? record.documentId : null,
                          patientId: record.patient.id,
                          episodeOfCareId: record.episodeOfCare.id,
                          status: record.status,
                          mode: record.mode
                        }
                      ];
                      this.showDocumentShareModal = true;
                    }
                  });
                }

                if (
                  (record.status == "Completed" &&
                    this.hasCurrentUserDocumentPermission(
                      record.form.id,
                      "hasCompleteAccess"
                    )) ||
                  (record.status != "Completed" &&
                    this.hasCurrentUserDocumentPermission(
                      record.form.id,
                      "hasEntryAccess"
                    ))
                ) {
                  actions.push({
                    content: "Edit",
                    callback: () => this.openDocumentEditor(record)
                  });
                }

                if (
                  record.status != "Completed" &&
                  this.hasCurrentUserDocumentPermission(
                    record.form.id,
                    "hasEntryAccess"
                  ) &&
                  (record.category == "main" ||
                    record.category == "masterTreatmentPlan" ||
                    record.category == "doctorOrder")
                ) {
                  actions.push({
                    content: "Delete",
                    callback: () => {
                      this.$dialog
                        .alert(
                          {
                            title:
                              "Are you sure you want to delete this record?"
                          },
                          {
                            view: "confirm-delete"
                          }
                        )
                        .then(async () => {
                          let result = null;
                          if (record.type == "Document")
                            result = await formSubmitterServer.delete(
                              record.documentId
                            );
                          else
                            result = await documentGroupServer.delete(
                              record.documentId
                            );
                          if (result.errorCode) {
                            this.$dialog.alert("Error: " + result.message);
                          } else {
                            this.fetchDocuments();
                            this.showAlertSuccess();
                          }
                        });
                    }
                  });
                }
                return this.createDropdownButton({
                  items: actions
                });
              }
            }
          ]
        }
      ].filter(f => !this.selectedLocation || f.field != "location");
    },
    hasFilters() {
      return (
        this.filter.formId.length > 0 ||
        this.filter.eoc.length > 0 ||
        this.filter.status.length > 0 ||
        this.filter.location.length > 0 ||
        this.filter.creationDateFrom ||
        this.filter.creationDateTo ||
        this.filter.effectiveDateFrom ||
        this.filter.effectiveDateTo ||
        this.filter.patientStartDateFrom ||
        this.filter.patientStartDateTo ||
        this.filter.user.length > 0 ||
        this.filter.completedBy.length > 0
      );
    },
    pageSize: {
      get() {
        return this.filter.pageSize.toString();
      },
      set(newValue) {
        this.filter.pageSize = parseInt(newValue);
        this.changePage(0);
      }
    },
    exportFilter() {
      const userLocationIds = this.currentUser.accessToLocations.map(
        location => location.id
      );
      const locations =
        this.filter.location.length === 0
          ? userLocationIds
          : this.filter.location;
      return {
        eocsIds: this.filter.eoc.map(eoc => eoc.value),
        formIds: this.filter.formId.map(f => f.value),
        fromCreation: this.filter.creationDateFrom,
        toCreation: this.filter.creationDateTo,
        fromEffectiveDate: this.filter.effectiveDateFrom,
        toEffectiveDate: this.filter.effectiveDateTo,
        fromPatientStartDate: this.filter.patientStartDateFrom,
        toPatientStartDate: this.filter.patientStartDateTo,
        createByIds: this.filter.user.map(u => u.value),
        completedByIds: this.filter.completedBy.map(cby => cby.value),
        statuses: this.filter.status.map(s => {
          if (s.value == "Pending") return 1;
          if (s.value == "Completed") return 2;
          return 0;
        }),
        orderBy: this.filter.orderBy,
        sort: this.filter.orderByDescending ? "DESC" : "ASC",
        locationIds: this.selectedLocation
          ? [this.selectedLocation]
          : locations,
        documentRefNumber:
          this.filter.searchPhrase.length >= 3 ? this.filter.searchPhrase : "",
        assignedToMe: this.assignedToMe
      };
    }
  },
  watch: {
    showing: {
      handler: function(newValue) {
        if (newValue) {
          this.fetchInitialData();
          this.computeHeights();
          this.fetchLocationOptions();
        }
      }
    },
    "filter.searchPhrase": function() {
      this.filter.page = 0;
      if (
        this.filter.searchPhrase.length == 0 ||
        this.filter.searchPhrase.length >= 3
      ) {
        this.searchDocuments();
      }
    },
    "filter.formId": function() {
      this.filter.page = 0;
      this.searchDocuments();
      this.computeHeights();
    },
    "filter.eoc": function() {
      this.filter.page = 0;
      this.searchDocuments();
      this.computeHeights();
    },
    "filter.status": function() {
      this.filter.page = 0;
      this.searchDocuments();
      this.computeHeights();
    },
    "filter.location": function() {
      this.filter.page = 0;
      this.searchDocuments();
      this.computeHeights();
    },
    "filter.creationDateFrom": function() {
      this.filter.page = 0;
      this.searchDocuments();
      this.computeHeights();
    },
    "filter.creationDateTo": function() {
      this.filter.page = 0;
      this.searchDocuments();
      this.computeHeights();
    },
    "filter.effectiveDateFrom": function() {
      this.filter.page = 0;
      this.searchDocuments();
      this.computeHeights();
    },
    "filter.effectiveDateTo": function() {
      this.filter.page = 0;
      this.searchDocuments();
      this.computeHeights();
    },
    "filter.patientStartDateFrom": function() {
      this.filter.page = 0;
      this.searchDocuments();
      this.computeHeights();
    },
    "filter.patientStartDateTo": function() {
      this.filter.page = 0;
      this.searchDocuments();
      this.computeHeights();
    },
    "filter.user": function() {
      this.filter.page = 0;
      this.searchDocuments();
      this.computeHeights();
    },
    "filter.completedBy": function() {
      this.filter.page = 0;
      this.searchDocuments();
      this.computeHeights();
    },
    selectedFilter: function() {
      this.$refs.filterDropdown.updatePopper();
    }
  }
};
</script>

<style scoped>
.container-main {
  height: 45px;
}
.b-dropdown-form:focus {
  outline: none !important;
}

.filter-value {
  min-width: 100px;
  height: 29px;
  color: #a6a6a6;
  font-size: 14px;
  padding-left: 10px;
}
.filter-value-delete {
  position: absolute;
  top: -8px;
  right: -8px;
}
.filter-value-delete:hover {
  cursor: pointer;
}
.clear-all-filters:hover {
  cursor: pointer;
}
.filter-title {
  font-size: 16px;
}
.admission-data {
  font-size: 13px;
}

.filters-container >>> .container-filter-main-menu {
  min-width: 250px;
  left: -17px;
}

.documents-container >>> .b-grid-header .b-checkbox {
  margin-left: -7px;
}
.documents-container >>> .file-result-row .b-checkbox-selection div {
  display: none;
}
.documents-container >>> .b-grid-container .b-container {
  max-height: calc(
    100vh - var(--document-list-filters-container-height) - 240px
  );
  min-height: calc(
    100vh - var(--document-list-filters-container-height) - 240px
  ) !important;
}
.vertical-separator {
  width: 1px;
  border-left: 1px solid;
  height: 100%;
}
.color-filter {
  color: #909db8;
}

.documents-container >>> .b-action-cell .b-action-ct {
  display: flex;
  align-items: center;
  gap: 5px;
}

.search-input {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  width: 320px;
}

.gap-massdocument {
  padding-right: 20px;
}
</style>
